import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { FieldError } from 'react-hook-form/dist/types';

interface BaseTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: FieldError | unknown;
}

/** Base textarea component. */
const BaseTextArea = forwardRef<HTMLTextAreaElement, BaseTextAreaProps>((props, ref) => {
  const { invalid, className, ...rest } = props;

  const textAreaClassName = classNames('form-control', className, { invalid });

  return (
    <div className="form-group">
      <textarea ref={ref} className={textAreaClassName} {...rest} />
    </div>
  );
});

BaseTextArea.displayName = 'BaseTextArea';

export default BaseTextArea;
